const style = {
  size: 'small',
  sx: {
    pt: '6px',
    pl: '20px',
    pb: '6px',
    color: 'text.secondary',
  },
  text: {
    variant: 'overline',
  },
} as const;

export default style;
